import { createDispatchMap } from "@ngxs/store";
import { TrackByFunction } from "@angular/core";

import { TableStateActions } from "./state/table.actions";
import { Sort } from "@angular/material/sort";

export abstract class JtmsDataconnectTable<T> {

  protected tableName!: string;

  private actions = createDispatchMap({
    updateTableState: TableStateActions.UpdateState,
    updateTableSort: TableStateActions.UpdateSort,
  })

  protected sortChange(event: Sort) {
    this.actions.updateTableSort(this.tableName, event);
  }

  protected trackById(index: number, item: any): TrackByFunction<T> {
    return item.containerNumber ? item.containerNumber : item.uid;
  }
}
